import { render } from "./QLegend.vue?vue&type=template&id=74fd393a&scoped=true"
import script from "./QLegend.vue?vue&type=script&lang=js"
export * from "./QLegend.vue?vue&type=script&lang=js"

import "./QLegend.vue?vue&type=style&index=0&id=74fd393a&scoped=true&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fd393a"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
